import { UserData } from "./types";

export const initialData: Record<string, UserData> = {
  "/": {
    content: [],
    root: {
      props: {
        live: false,
        meta: {
          seo_title: "Lorem Ipsum SEO Title",
          seo_desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
          canonical_url: "https://example.com",
          no_index: false,
          seo_icon: "https://example.com/default-icon.png",
          header_items: "tr_student",
          // header_items: {
          //   name: "Header Item 1",
          //   language: "tr",
          //   profile: "default",
          //   components: [
          //     {
          //       type: "headermenucomponent",
          //       data: {
          //         type: "primary",
          //         name: "Menu Item 1",
          //         image: "https://example.com/image1.png",
          //         alt_text: "Menu Item 1 Alt Text",
          //         desktop_position: "left",
          //         mobile_position: "top",
          //         hide_for_authenticated_user: false,
          //         hide_for_unauthenticated_user: false,
          //         label: "Menu 1",
          //         url: "/menu-1",
          //         icon: "https://example.com/icon1.png",
          //         title: "Menu Item 1 Title",
          //         description: "Description for Menu Item 1",
          //         target: "_self",
          //         childs: [
          //           {
          //             title: "Child Item 1",
          //             type: "link",
          //             url: "/child-1",
          //             icon: "https://example.com/child-icon1.png",
          //             description: "Child Item 1 Description",
          //             badge_text: "New",
          //             badge_type: "info",
          //             childs: [],
          //             desktop_position: "left",
          //             mobile_position: "top",
          //             is_for_authenticated_user: true,
          //           },
          //         ],
          //         badge_text: "Hot",
          //         badge_type: "warning",
          //       },
          //     },
          //     {
          //       type: "headermenucomponent",
          //       data: {
          //         type: "primary",
          //         name: "Menu Item 1",
          //         image: "https://example.com/image1.png",
          //         alt_text: "Menu Item 1 Alt Text",
          //         desktop_position: "left",
          //         mobile_position: "top",
          //         hide_for_authenticated_user: false,
          //         hide_for_unauthenticated_user: false,
          //         label: "Menu 1",
          //         url: "/menu-1",
          //         icon: "https://example.com/icon1.png",
          //         title: "Menu Item 1 Title",
          //         description: "Description for Menu Item 1",
          //         target: "_self",
          //         childs: [
          //           {
          //             title: "Child Item 1",
          //             type: "link",
          //             url: "/child-1",
          //             icon: "https://example.com/child-icon1.png",
          //             description: "Child Item 1 Description",
          //             badge_text: "New",
          //             badge_type: "info",
          //             childs: [],
          //             desktop_position: "left",
          //             mobile_position: "top",
          //             is_for_authenticated_user: true,
          //           },
          //         ],
          //         badge_text: "Hot",
          //         badge_type: "warning",
          //       },
          //     },
          //     {
          //       type: "headermenucomponent",
          //       data: {
          //         type: "primary",
          //         name: "Menu Item 1",
          //         image: "https://example.com/image1.png",
          //         alt_text: "Menu Item 1 Alt Text",
          //         desktop_position: "left",
          //         mobile_position: "top",
          //         hide_for_authenticated_user: false,
          //         hide_for_unauthenticated_user: false,
          //         label: "Menu 1",
          //         url: "/menu-1",
          //         icon: "https://example.com/icon1.png",
          //         title: "Menu Item 1 Title",
          //         description: "Description for Menu Item 1",
          //         target: "_self",
          //         childs: [
          //           {
          //             title: "Child Item 1",
          //             type: "link",
          //             url: "/child-1",
          //             icon: "https://example.com/child-icon1.png",
          //             description: "Child Item 1 Description",
          //             badge_text: "New",
          //             badge_type: "info",
          //             childs: [],
          //             desktop_position: "left",
          //             mobile_position: "top",
          //             is_for_authenticated_user: true,
          //           },
          //         ],
          //         badge_text: "Hot",
          //         badge_type: "warning",
          //       },
          //     },
          //   ],
          // },
          landing_page_header: "student",
          language: "tr",
          slug: "tr/test",
          name: "Test Page",
          content_type: "landing-page",
        },
        headerBannerData: {
          name: "Default Banner",
          data: {
            cta_title: "Learn More",
            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
            cta_link: "https://example.com",
          },
        },
      },
    },
    zones: {},
  },
};
